module.exports = __webpack_public_path__ + "img/icon_handzone.d7855f69.png";